import { useState } from "react";

import markdownIt from 'markdown-it';
import mila from "markdown-it-link-attributes";
import MessageActions from "../../MessageActions";
import ParentChatMessage from "../../ParentChatMessage";
import { submitFeedback } from "../Ai";

let md = markdownIt({ html: false, linkify: true, typographer: true, breaks: false });
md.use(mila, { attrs: { target: "_blank", rel: "noopener", } });

export default function Text(props: any) {
  const { message, topMargin } = props;
  const [hasClickedThumbsUp, setHasClickedThumbsUp] = useState(props.hasClickedThumbsUp || false);
  const [hasClickedThumbsDown, setHasClickedThumbsDown] = useState(props.hasClickedThumbsDown || false);
  const [showMessageIcon, setShowMessageIcon] = useState(false);

  const handleLikes = (type: string) => {
    if (type === "thumbsUp") {
      setHasClickedThumbsUp(true);
      setHasClickedThumbsDown(false);
      submitFeedback({ mid: message.mid, hasClickedThumbsUp: true, hasClickedThumbsDown: false })
    } else {
      setHasClickedThumbsUp(false);
      setHasClickedThumbsDown(true);
      submitFeedback({ mid: message.mid, hasClickedThumbsUp: false, hasClickedThumbsDown: true })
    }
  }

  return <>
    {
      message.messagedBy !== 'user' && (
        <div className={`ele-text-message rounded-xl py-2 px-4 max-w-80 bg-primaryBgColor relative ${topMargin} inline-block`}
          onMouseEnter={() => { setShowMessageIcon(true) }} onMouseLeave={() => { setShowMessageIcon(false) }}>
          {(
            message._parent
              ? <ParentChatMessage parentMessage={message._parent} backgroundColor={'#EBEDED'} messagePosition={message.position} />
              : null
          )}
          {
            message.shouldFeedbackVisible
              ? <div className={`ele-text-message-label prose ${message?._parent ? 'ml-4' : ''}`} dangerouslySetInnerHTML={{ __html: md.render(message.label) }} />
              : <div className={message?._parent ? 'ml-4 ele-text-message-label prose' : 'ele-text-message-label prose'} dangerouslySetInnerHTML={{ __html: md.render(message.label) }} />
          }
          
          {
            // To be deprecated
            (message.position !== 'right' && message.shouldFeedbackVisible) && (
              <div className="text-right mt-1 ele-text-message-feedback">
                {
                  hasClickedThumbsUp
                    ?
                    <img onClick={() => handleLikes("thumbsUp")} alt="refresh" className="transition-transform duration-250 transform hover:scale-150 inline-block w-6 cursor-pointer"
                      src={process.env.REACT_APP_CDN + "/thumbs-up.svg"}
                    />
                    :
                    <img onClick={() => handleLikes("thumbsUp")} src={process.env.REACT_APP_CDN + "/thumbs-up-blank.svg"} alt="refresh" className="transition-transform duration-250 transform hover:scale-150 inline-block w-6 cursor-pointer"
                      onMouseEnter={(e) => {
                        (e.target as any).src = process.env.REACT_APP_CDN + "/thumbs-up.svg";
                      }}
                      onMouseLeave={(e) => {
                        (e.target as any).src = process.env.REACT_APP_CDN + "/thumbs-up-blank.svg";
                      }}
                    />

                }
                {
                  hasClickedThumbsDown
                    ?
                    <img onClick={() => handleLikes("thumbsDown")} src={process.env.REACT_APP_CDN + "/thumbs-down.svg"} alt="refresh" className="transition-transform duration-250 transform hover:scale-150 inline-block w-6 cursor-pointer" />

                    :
                    <img onClick={() => handleLikes("thumbsDown")} src={process.env.REACT_APP_CDN + "/thumbs-down-blank.svg"} alt="refresh" className="transition-transform duration-250 transform hover:scale-150 inline-block w-6 cursor-pointer"
                      onMouseEnter={(e) => {
                        (e.target as any).src = process.env.REACT_APP_CDN + "/thumbs-down.svg";
                      }}
                      onMouseLeave={(e) => {
                        (e.target as any).src = process.env.REACT_APP_CDN + "/thumbs-down-blank.svg";
                      }} />

                }
              </div>
            )
          }
          <MessageActions message={message} show={showMessageIcon} />
        </div>
      )
    }
  </>
}